"use client";

import { useEffect } from "react";
import { AlertTriangle, RefreshCw, ChevronLeft } from "lucide-react";
import { useT } from "@/components/common/locale-context";

export default function AppError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useT();
  const msg = error?.message || "";
  const isSkew = /Failed to find Server Action|older or newer deployment|Connection closed|Failed to fetch|deployment/i.test(msg);

  useEffect(() => {
    if (isSkew) {
      const tmr = setTimeout(() => window.location.reload(), 1400);
      return () => clearTimeout(tmr);
    }
  }, [isSkew]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="glass rise w-[440px] max-w-full rounded-[10px] p-8 text-center">
        <span
          className="mx-auto grid size-14 place-items-center rounded-[10px]"
          style={
            isSkew
              ? { background: "var(--m-tasks-soft)", color: "var(--m-tasks)" }
              : { background: "var(--s-stuck-soft)", color: "var(--s-stuck)" }
          }
        >
          {isSkew ? <RefreshCw className="size-7 animate-spin" /> : <AlertTriangle className="size-7" />}
        </span>
        <h1 className="mt-5 text-[19px] font-bold tracking-tight text-[var(--ink)]">
          {isSkew ? t.errors.appUpdatedTitle : t.errors.generic}
        </h1>
        <p className="mx-auto mt-2 max-w-[340px] text-[13.5px] leading-relaxed text-[var(--ink-2)]">
          {isSkew ? t.errors.appUpdatedSub : t.errors.retryHint}
        </p>
        <div className="mt-6 flex items-center justify-center gap-2">
          <button
            onClick={() => (isSkew ? window.location.reload() : reset())}
            className="inline-flex items-center gap-1.5 rounded-[10px] bg-[var(--btn-bg)] px-4 py-2 text-[13px] font-semibold text-[var(--btn-fg)] transition-colors hover:bg-[var(--btn-bg-hover)]"
          >
            <RefreshCw className="size-4" /> {t.errors.reload}
          </button>
          {!isSkew && (
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-1.5 rounded-[10px] px-4 py-2 text-[13px] font-semibold text-[var(--ink-2)] transition-colors hover:bg-[var(--w-hover)]"
            >
              <ChevronLeft className="size-4" /> {t.common.back}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
